import { render } from "./RuleWaitingListView.vue?vue&type=template&id=164c7491"
import script from "./RuleWaitingListView.vue?vue&type=script&lang=js"
export * from "./RuleWaitingListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/RuleWaitingListView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "164c7491"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('164c7491', __exports__)) {
    api.reload('164c7491', __exports__)
  }
  
  module.hot.accept("./RuleWaitingListView.vue?vue&type=template&id=164c7491", () => {
    api.rerender('164c7491', render)
  })

}


export default __exports__